import { render, staticRenderFns } from "./Statement.vue?vue&type=template&id=0dca4db4&scoped=true&"
import script from "./Statement.vue?vue&type=script&lang=ts&"
export * from "./Statement.vue?vue&type=script&lang=ts&"
import style0 from "./Statement.vue?vue&type=style&index=0&id=0dca4db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca4db4",
  null
  
)

export default component.exports